/**
 *
 * IndexPage
 *
 *
 */

import React from 'react';
import styled from 'styled-components';

import RichText from 'components/content/RichText';
import Headline from 'components/content/Headline';
import PullQuote from 'components/content/PullQuote';
import BlockQuote from 'components/content/BlockQuote';
import CTA from 'components/content/CTA';
import CTATwoUp from 'components/content/CTATwoUp';

import ImageOneUp from 'components/content/ImageOneUp';
import ImageTwoUp from 'components/content/ImageTwoUp';
import PhotoGallery from 'components/content/PhotoGallery';

import VideoEmbed from 'components/content/VideoEmbed';

import LineBreak from 'components/content/LineBreak';


function ContentBlock({ block, customBlockStyleClass }) {
  let Block = null;

  switch(block.typeHandle) {
    case 'richText':
      return (
        <RichText 
          block={block}
          className={'rich-text-' + customBlockStyleClass}
        />
      )
      break;
    case 'imageOneUp':
      return (
        <ImageOneUp
          block={block}
          className={'image-one-up-' + customBlockStyleClass} 
        />
      )
      break;
    case 'imageTwoUp':
      return (
        <ImageTwoUp 
          block={block}
        />
      )
    case 'photoGallery':
      return (
        <PhotoGallery 
          block={block}
        />
      )
    case 'headline':
      return (
        <Headline
          block={block}
        />
      )
    case 'pullQuote':
      return (
        <PullQuote 
          block={block}
        />
      )
    case 'lineBreak':
      return (
        <LineBreak 
          block={block}
        />
      )
    case 'blockQuote':
      return (
        <BlockQuote 
          block={block}
        />
      )
    case 'videoEmbed':
      return (
        <VideoEmbed 
          block={block}
        />
      )
    case 'cta':
        return (
          <CTA 
            block={block}
          />
        )
    case 'ctaTwoUp':
        return (
          <CTATwoUp 
            block={block}
          />
        )
        break;
    default:
      return (
        <h3>This Block is not yet supported!</h3>
      )
      break;
  }

  // return (
  //   <Block 
  //     block={block}
  //   />
  // )
};

function ContentBlocks({ blocks, customBlockStyleClass }) {
  return blocks.map((block) => {
    return (
      <ContentBlock 
        block={block}
        key={block.typeHandle + Math.random()}
        customBlockStyleClass={customBlockStyleClass}
      />
    )
  })
};




const ContentEngine = ({ blocks, customBlockStyleClass }) => {

  return (
    <ContentBlocks 
      blocks={blocks}
      customBlockStyleClass={customBlockStyleClass}
    />
  );
};

ContentEngine.propTypes = {

};

export default ContentEngine;

const EmptyBlock = styled.div`

`;